/**
 * Reusable component for individual row remediation action button
 * Shows plus or minus button based on item's remediation status
 */
import React from "react";

const RemediationActionButton = ({
  row,
  shouldShowPlus,
  onAdd,
  onRemove,
  clientType,
  remediationType = "Item",
}) => {
  /*if (clientType !== "Admin") {
    return null;
  }*/

  return (
    <td>
      {shouldShowPlus ? (
        <button
          onClick={onAdd({
            ...row,
            remediationType: remediationType,
          })}
        >
          <span className="fa fa-plus action_icon"></span>
        </button>
      ) : (
        <button onClick={onRemove(row?._id)}>
          <span className="fa fa-minus action_icon"></span>
        </button>
      )}
    </td>
  );
};

export default RemediationActionButton;
